import {
  createSlice,
  isFulfilled,
  isPending,
  isRejected,
} from "@reduxjs/toolkit";

import type { ErrorsFromBackendType, SearchState } from "../ts";
import {
  clearAppError,
  clearAppSession,
} from "../../common/redux/globalActions";
import { GetSitterThunk, GetTopSittersThunk } from "./thunk";

const initialState: SearchState = {
  filters: undefined,
  pagination: {
    limit: 0,
    offset: 0,
  },
  online: undefined,
  is_loading: false,
  error: null,

  current: null,

  trending: undefined,
  trending_pagination: {
    limit: 0,
    offset: 0,
  },
  trending_is_loading: false,

  favorite_ids: [],
};

export const searchSlice = createSlice({
  name: "search",
  initialState: initialState,
  reducers: {
    setApiError: (state, action) => {
      state.error = { ...state.error, ...action.payload };
    },
    clearState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(clearAppSession, () => initialState)
      .addCase(clearAppError, (state, action) => {
        if (action.payload && state.error && action.payload in state.error) {
          delete state.error[action.payload];
        } else {
          state.error = null;
        }
      })
      .addMatcher(isFulfilled(GetTopSittersThunk), (state, action) => {
        const { results, ...rest } = action.payload;
        if (!state.online || action.meta.arg.offset === 0) {
          state.online = action.payload;
        } else {
          state.online = {
            ...rest,
            results: [...state.online.results, ...results],
          };
        }

        const { limit, offset } = action.meta.arg;
        state.pagination.limit = limit;
        state.pagination.offset = offset;
        // state.filters = filters;
        state.is_loading = false;
        state.error = null;
      })
      .addMatcher(isPending(GetTopSittersThunk, GetSitterThunk), (state) => {
        state.error = null;
        state.is_loading = true;
      })
      .addMatcher(
        isRejected(GetTopSittersThunk, GetSitterThunk),
        (state, action) => {
          state.error = action.payload as ErrorsFromBackendType;
          state.is_loading = false;
        },
      );
  },
});

export const searchActions = searchSlice.actions;

export const { reducer: searchReducer } = searchSlice;

export default searchReducer;
